import {RequestStatus} from './network/managedRequest';
import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {PbRequest} from './pbRequest';

export interface PbGenericListApiDto<T> {
    list: T[];
}

export interface PbGenericRequest {
    status: RequestStatus;
    errors: string[];
}

type PbRequestBaseAction = PayloadAction<{ identifier: PbRequest }>;
type PbRequestErrorAction = PayloadAction<{
    identifier: PbRequest;
    errors: string[];
}>;

export type PbRequestStore = {
    [key in PbRequest]: PbGenericRequest;
};

const initialState: PbRequestStore = Object.keys(PbRequest).reduce(
    (store: PbRequestStore, key: string) => ({
        ...store,
        [key]: { status: 'INITIAL', errors: [] },
    }),
    {} as PbRequestStore
);

const pbRequestSlice = createSlice({
    name: 'pbRequest',
    initialState,
    reducers: {
        pbRequestStart(state: PbRequestStore, action: PbRequestBaseAction) {
            state[action.payload.identifier] = {
                status: RequestStatus.PENDING,
                errors: [],
            };
        },
        pbRequestSuccess(state: PbRequestStore, action: PbRequestBaseAction) {
            state[action.payload.identifier] = {
                status: RequestStatus.SUCCESS,
                errors: [],
            };
        },
        pbRequestFailure(state: PbRequestStore, action: PbRequestErrorAction) {
            state[action.payload.identifier] = {
                status: RequestStatus.FAILURE,
                errors: action.payload.errors,
            };
        },
        pbRequestReset(state: PbRequestStore, action: PbRequestBaseAction) {
            state[action.payload.identifier] = {
                status: RequestStatus.INITIAL,
                errors: [],
            };
        },
    },
});

export function pbRequestStart(identifier: PbRequest) {
    return pbRequestSlice.actions.pbRequestStart({ identifier });
}

export function pbRequestSuccess(identifier: PbRequest) {
    return pbRequestSlice.actions.pbRequestSuccess({ identifier });
}

export function pbRequestFailure(identifier: PbRequest, errors: string[]) {
    return pbRequestSlice.actions.pbRequestFailure({ identifier, errors });
}

export function pbRequestReset(identifier: PbRequest) {
    return pbRequestSlice.actions.pbRequestReset({ identifier });
}

export const pbRequestReducer = pbRequestSlice.reducer;
